import { render, staticRenderFns } from "./flight-pad-bags.vue?vue&type=template&id=5d2305b1&scoped=true&"
import script from "./flight-pad-bags.vue?vue&type=script&lang=js&"
export * from "./flight-pad-bags.vue?vue&type=script&lang=js&"
import style0 from "./flight-pad-bags.vue?vue&type=style&index=0&id=5d2305b1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2305b1",
  null
  
)

export default component.exports